import React from "react";
import { ReactComponent as Abstract } from "assets/img/vectors/homepage/abstract-4.svg";


const Abstract4 = () => (
    <Abstract />
)

export default Abstract4;